import { createUseStyles } from 'react-jss';

const useStyle = createUseStyles(() => ({
  badge: (props) => ({
    fontSize: `${Math.floor(props.size / 1.5)}px`,
    width: props.fab ? props.size : 'auto',
    height: props.fab ? props.size : 'auto',
    borderRadius: (props.size / 2) + 1,
    display: 'inline-block',
    textAlign: 'center',
    verticalAlign: 'middle',
    lineHeight: props.fab ? `${props.size + (props.size * 0.1)}px` : 'auto',
  }),
}));

export default useStyle;
